"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomHeader = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const styles_1 = require("../styles");
const CustomHeader = ({ header, onChange, onBlur, onDelete, readOnly }) => {
    const { spacing } = (0, ui_1.useTheme2)();
    const commonStyles = (0, styles_1.useCommonStyles)();
    const styles = {
        container: (0, css_1.css)({
            alignItems: 'center',
        }),
        input: (0, css_1.css)({
            minWidth: '100%',
        }),
        headerNameField: (0, css_1.css)({
            width: '40%',
            marginRight: 0,
            paddingRight: spacing(1),
        }),
        headerValueField: (0, css_1.css)({
            width: '45%',
            marginRight: 0,
        }),
        removeHeaderBtn: (0, css_1.css)({
            margin: `0 0 3px 10px`,
        }),
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.InlineFieldRow, { className: styles.container },
            react_1.default.createElement(ui_1.InlineField, { label: "Header", labelWidth: 9, grow: true, className: styles.headerNameField, htmlFor: `custom-header-${header.id}-name-input`, disabled: readOnly },
                react_1.default.createElement(ui_1.Input, { id: `custom-header-${header.id}-name-input`, placeholder: "X-Custom-Header", value: header.name, width: 12, onChange: (e) => onChange(Object.assign(Object.assign({}, header), { name: e.currentTarget.value })), onBlur: onBlur, className: styles.input })),
            react_1.default.createElement(ui_1.InlineField, { label: "Value", labelWidth: 9, grow: true, className: (0, css_1.cx)(commonStyles.inlineFieldWithSecret, styles.headerValueField), htmlFor: `custom-header-${header.id}-value-input`, disabled: readOnly },
                react_1.default.createElement(ui_1.SecretInput, { id: `custom-header-${header.id}-value-input`, isConfigured: header.configured, placeholder: "Header value", value: header.value, width: 12, onChange: (e) => onChange(Object.assign(Object.assign({}, header), { value: e.currentTarget.value })), onReset: readOnly ? () => { } : () => onChange(Object.assign(Object.assign({}, header), { configured: false, value: '' })), onBlur: onBlur, className: styles.input })),
            react_1.default.createElement(ui_1.IconButton, { name: "trash-alt", tooltip: "Remove header", tooltipPlacement: "top", className: styles.removeHeaderBtn, onClick: onDelete, type: "button", disabled: readOnly }))));
};
exports.CustomHeader = CustomHeader;
//# sourceMappingURL=CustomHeader.js.map